import React, { PureComponent } from 'react';

class Checkbox extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <label>
        <input type="checkbox" checked={this.props.getState()} onChange={() => this.props.invertState()} />
        {this.props.title}
      </label>
    );
  }
}

export default Checkbox;
